import React from "react";
import { 
  Container, 
  Card,
  CardContent,
  Box, 
  Skeleton,
  Grid
} from "@mui/material";

function RoomCreatePageSkeleton() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Card>
        <CardContent>
          {/* Page title */}
          <Skeleton 
            variant="text" 
            width={200} 
            height={48} 
            sx={{ mx: "auto", mb: 4 }} 
          />
          
          {/* Form fields */}
          <Box sx={{ mb: 4 }}>
            {/* Room name field */}
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width={100} height={24} sx={{ mb: 1 }} />
              <Skeleton variant="rectangular" width="100%" height={56} />
            </Box>
            
            {/* Room image upload */}
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width={120} height={24} sx={{ mb: 1 }} />
              <Skeleton 
                variant="rectangular" 
                width="100%" 
                height={200} 
                sx={{ borderRadius: 1 }} 
              />
            </Box>
            
            {/* Dynamic fields grid */}
            <Grid container spacing={2}>
              {[1, 2, 3, 4].map((item) => (
                <Grid item xs={12} sm={6} key={item}>
                  <Box>
                    <Skeleton variant="text" width={80} height={24} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangular" width="100%" height={56} />
                  </Box>
                </Grid>
              ))}
            </Grid>
            
            {/* Additional form fields */}
            <Box sx={{ mt: 3 }}>
              <Skeleton variant="text" width={150} height={24} sx={{ mb: 1 }} />
              <Skeleton variant="rectangular" width="100%" height={120} />
            </Box>
          </Box>
          
          {/* Action buttons */}
          <Box sx={{ 
            display: "flex", 
            gap: 2, 
            justifyContent: "center",
            mt: 4 
          }}>
            <Skeleton variant="rectangular" width={100} height={48} />
            <Skeleton variant="rectangular" width={120} height={48} />
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}

export default RoomCreatePageSkeleton;